import {Department} from './Department';

export class OrderModel {
  department: Department;
  deliveryOption: string;
  deliveryAddress: string;
  isScheduled: string;
  scheduledDateVal: string;
  scheduledTimeVal: string;
  paymentMethod: string;
  number_of_people: number;
  name: string;
  phone: object;
  email: string;
  needInvoice: boolean;
  companyName: string;
  companyAddress: string;
  companyNip: number;
  cart: any;
  comment: string;
  agreement: boolean;
  privacy_agreement: boolean;
  status: number;
  checksum: string;
  timeAdded: string;
  coupon_id: number;
  coupon_name: string;
}
